import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, 4, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    [{ color: [] }, { background: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const QUILL_FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "color",
  "background",
  "link",
  "image",
  "video",
];

export default function ContentEditor({ value, index, onChange }) {
  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={(v) => onChange(v, index)}
      modules={QUILL_MODULES}
      formats={QUILL_FORMATS}
      className="mb-4 bg-white rounded"
      placeholder="Write your content here..."
    />
  );
}
